import { FILE_TYPE_PNG, MAX_PNG_SIZE } from '@constants/global';

/** Rejects when the browser cannot decode the image, so callers can tell that apart from a wide PNG. */
export const isLargePng = async (type: string, fileEl: { src: string; file: File }): Promise<boolean> => {
  const isPng = type.includes(FILE_TYPE_PNG);
  if (!isPng) return false;
  return new Promise<boolean>((resolve, reject) => {
    const img = document.createElement('img');
    img.src = fileEl.src;

    img.onload = () => {
      const fileWidth = img.width;
      const isBiggerSize = fileWidth > MAX_PNG_SIZE;
      resolve(isBiggerSize);
    };

    img.onerror = () => {
      reject(new Error('Unreadable image'));
    };
  });
};
